import { CohortStepType } from 'src/types/cohorts';
import { QueryValidationStep } from './query-validation';
import { DataExtractionStep } from './data-extraction';
import { CodesSelectionStep } from './codes-selection';
import { ResultStep } from './result';

export const STEP_COMPONENTS = {
  [CohortStepType.QueryValidation]: QueryValidationStep,
  [CohortStepType.DataExtraction]: DataExtractionStep,
  [CohortStepType.CodesSelection]: CodesSelectionStep,
  [CohortStepType.Results]: ResultStep,
};
